import { render, staticRenderFns } from "./RenameEvent.vue?vue&type=template&id=2ca8b73a&"
import script from "./RenameEvent.vue?vue&type=script&lang=js&"
export * from "./RenameEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports